import { render, staticRenderFns } from "./sales-order-edi-v1.vue?vue&type=template&id=d053acfa"
import script from "./sales-order-edi-v1.vue?vue&type=script&lang=js"
export * from "./sales-order-edi-v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports